import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import { lazy } from "react";

const Residential = lazy(() => import("../pages/residential/page"));
const Commercial = lazy(() => import("../pages/commercial/page"));
const Services = lazy(() => import("../pages/services/page"));
const Repairs = lazy(() => import("../pages/services/repairs/page"));
const Contact = lazy(() => import("../pages/contact/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/residential",
    element: <Residential />,
  },
  {
    path: "/commercial",
    element: <Commercial />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/repairs",
    element: <Repairs />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
